var _path, _path2, _g, _rect, _g2, _defs;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function Svg404Error1(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 215,
    height: 168,
    viewBox: "0 0 215 168",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M5.14915 83.5057V73.0298L36.0085 24.2727H44.7443V39.1875H39.4176L18.6435 72.1065V72.6747H61.7188V83.5057H5.14915ZM39.8438 97V80.3097L39.9858 75.6222V24.2727H52.4148V97H39.8438Z",
    fill: "#333333"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M153.149 83.5057V73.0298L184.009 24.2727H192.744V39.1875H187.418L166.643 72.1065V72.6747H209.719V83.5057H153.149ZM187.844 97V80.3097L187.986 75.6222V24.2727H200.415V97H187.844Z",
    fill: "#333333"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    filter: "url(#filter0_d_3298_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M71 60.443C71 80.5687 87.2442 96.8859 107.28 96.8859C113.348 96.8859 119.064 95.3923 124.082 92.7506L159.237 148.759C161.393 152.185 165.993 153.044 169.227 150.617C172.247 148.349 172.898 144.073 170.696 140.993L132.027 87.0844C139.118 80.4287 143.56 70.9539 143.56 60.443C143.56 40.3172 127.316 24 107.28 24C87.2442 24 71 40.3172 71 60.443ZM75.9811 60.443C75.9811 43.0803 89.9949 28.9941 107.289 28.9941C124.584 28.9941 138.597 43.071 138.597 60.443C138.597 77.8056 124.584 91.8918 107.289 91.8918C90.0042 91.8918 75.9811 77.815 75.9811 60.443Z",
    fill: "#2196F3"
  }))), /*#__PURE__*/React.createElement("mask", {
    id: "mask0_3298_3",
    style: {
      maskType: "alpha"
    },
    maskUnits: "userSpaceOnUse",
    x: 91,
    y: 45,
    width: 32,
    height: 32
  }, _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: 91,
    y: 45,
    width: 32,
    height: 32,
    fill: "#D9D9D9"
  }))), _g2 || (_g2 = /*#__PURE__*/React.createElement("g", {
    mask: "url(#mask0_3298_3)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M105.133 66.3336C105.133 64.5336 105.294 63.2391 105.616 62.4502C105.938 61.6614 106.622 60.8002 107.666 59.8669C108.577 59.0669 109.272 58.3725 109.75 57.7836C110.227 57.1947 110.466 56.5225 110.466 55.7669C110.466 54.8558 110.161 54.1002 109.55 53.5002C108.938 52.9002 108.088 52.6002 107 52.6002C105.866 52.6002 105.005 52.9447 104.416 53.6336C103.827 54.3225 103.411 55.0225 103.166 55.7336L99.7329 54.2669C100.2 52.8447 101.055 51.6114 102.3 50.5669C103.544 49.5225 105.111 49.0002 107 49.0002C109.333 49.0002 111.127 49.6502 112.383 50.9502C113.638 52.2502 114.266 53.8114 114.266 55.6336C114.266 56.7447 114.027 57.6947 113.55 58.4836C113.072 59.2725 112.322 60.1669 111.3 61.1669C110.211 62.2114 109.55 63.0058 109.316 63.5502C109.083 64.0947 108.966 65.0225 108.966 66.3336H105.133ZM107 74.3336C106.266 74.3336 105.638 74.0725 105.116 73.5502C104.594 73.028 104.333 72.4002 104.333 71.6669C104.333 70.9336 104.594 70.3058 105.116 69.7836C105.638 69.2614 106.266 69.0002 107 69.0002C107.733 69.0002 108.361 69.2614 108.883 69.7836C109.405 70.3058 109.666 70.9336 109.666 71.6669C109.666 72.4002 109.405 73.028 108.883 73.5502C108.361 74.0725 107.733 74.3336 107 74.3336Z",
    fill: "#333333"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("filter", {
    id: "filter0_d_3298_3",
    x: 63,
    y: 24,
    width: 117,
    height: 144,
    filterUnits: "userSpaceOnUse",
    colorInterpolationFilters: "sRGB"
  }, /*#__PURE__*/React.createElement("feFlood", {
    floodOpacity: 0,
    result: "BackgroundImageFix"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    in: "SourceAlpha",
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 127 0",
    result: "hardAlpha"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dy: 8
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 4
  }), /*#__PURE__*/React.createElement("feComposite", {
    in2: "hardAlpha",
    operator: "out"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    type: "matrix",
    values: "0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0 0.25 0"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in2: "BackgroundImageFix",
    result: "effect1_dropShadow_3298_3"
  }), /*#__PURE__*/React.createElement("feBlend", {
    mode: "normal",
    in: "SourceGraphic",
    in2: "effect1_dropShadow_3298_3",
    result: "shape"
  })))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(Svg404Error1);
export default __webpack_public_path__ + "static/media/404 error (1).4e4e099174bd50eaecb385814f9c69fb.svg";
export { ForwardRef as ReactComponent };